import { render } from "./index.vue?vue&type=template&id=a559105e&scoped=true"
const script = {}

import "./index.vue?vue&type=style&index=0&id=a559105e&lang=scss&scoped=true"

import exportComponent from "F:\\project\\2023\\山东博物馆大屏\\shandong\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a559105e"]])

export default __exports__